"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
	init: function init($section) {
		// Add settings from schema to current object
		Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

		if (isScreenSizeLarge() || this.cart_action == 'drawer') {
			this.initializeAjaxCart();
		} else {
			this.initializeAjaxCartOnMobile();
		}

		if (this.cart_action == 'drawer') {
			this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
			$(document).on('click', '[data-ajax-cart-trigger]', function (e) {
				e.preventDefault();
				Shopify.theme.jsAjaxCart.showDrawer();
				return false;
			});
		} else if (this.cart_action == 'mini_cart') {
			this.showMiniCartOnHover();
		}

		$(document).on('click', '.ajax-submit', function (e) {
			e.preventDefault();
			var $addToCartForm = $(this).closest('form');
			Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
			return false;
		});

		$(document).on('click', '[data-ajax-cart-delete]', function (e) {
			e.preventDefault();
			var lineID = $(this).parents('[data-line-item]').data('line-item');
			Shopify.theme.jsAjaxCart.removeFromCart(lineID);

			if (Shopify.theme.jsCart) {
				Shopify.theme.jsCart.removeFromCart(lineID);
			}

			return false;
		});
		$(document).on('click', '[data-ajax-cart-close]', function (e) {
			e.preventDefault();
			Shopify.theme.jsAjaxCart.hideDrawer();
			Shopify.theme.jsAjaxCart.hideMiniCart();
			return false;
		});
	},
	showMiniCartOnHover: function showMiniCartOnHover() {
		var $el = $('[data-ajax-cart-trigger]');
		$el.hover(function () {
			if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
				$('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
			} else {
				$el.addClass('show-mini-cart');
			}
		}, function () {
			$el.removeClass('show-mini-cart');
		});
	},
	hideMiniCart: function hideMiniCart() {
		if (this.cart_action != 'mini_cart') return false;
		var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
		$el.removeClass('show-mini-cart');
	},
	toggleMiniCart: function toggleMiniCart() {
		var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

		$el.attr('href', '#');
		$el.off('click').on('click', function (e) {
			// If user clicks inside the element, do nothing
			if (e.target.closest('[data-ajax-cart-mini_cart]')) {
				return;
			} // Loads content into ajaxCart container for mobile header


			Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

			$el.toggleClass('show-mini-cart'); // Calculate height of mini cart

			var announcementHeight = 0;
			var mobileHeaderHeight = parseInt($('.mobile-header').height());

			if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
				announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
			}

			$('.mobile-header .theme-ajax-cart').css({
				height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
			});
		});
	},
	showDrawer: function showDrawer() {
		if (this.cart_action != 'drawer') return false; // addToCart() calls showDrawer() unconditionally on every successful
		// add - including when the item was added FROM an upsell button that
		// lives inside the already-open drawer itself. Without this guard,
		// every one of those calls re-stole focus back to the close button
		// and re-bound a duplicate keydown listener, which from the user's
		// perspective looked like Tab "looping back to the first product"
		// and never reaching anything past it.

		if (this.ajaxCartDrawer.hasClass('is-visible')) return false;
		var self = this; // Remember what had focus so we can restore it when the drawer closes

		this.lastFocusedElement = document.activeElement;
		this.ajaxCartDrawer.addClass('is-visible');
		this.ajaxCartDrawer.attr('aria-hidden', 'false');
		$('.ajax-cart__overlay').addClass('is-visible');
		this.lockBodyScroll(); // Move keyboard/screen-reader focus into the drawer once its
		// content has had a chance to render

		window.setTimeout(function () {
			var $focusTarget = self.ajaxCartDrawer.find('[data-ajax-cart-close]');
			if (!$focusTarget.length) $focusTarget = self.ajaxCartDrawer;
			$focusTarget.trigger('focus');
		}, 100); // Esc closes the drawer, Tab/Shift+Tab is trapped inside it while open

		$(document).on('keydown.ajaxCartDrawer', function (e) {
			if (e.key === 'Escape' || e.keyCode === 27) {
				Shopify.theme.jsAjaxCart.hideDrawer();
			} else if (e.key === 'Tab' || e.keyCode === 9) {
				Shopify.theme.jsAjaxCart.trapFocus(e);
			}
		});
	},
	hideDrawer: function hideDrawer() {
		if (this.cart_action != 'drawer') return false;
		if (!this.ajaxCartDrawer.hasClass('is-visible')) return false;
		this.ajaxCartDrawer.removeClass('is-visible');
		this.ajaxCartDrawer.attr('aria-hidden', 'true');
		$('.ajax-cart__overlay').removeClass('is-visible');
		this.unlockBodyScroll();
		$(document).off('keydown.ajaxCartDrawer'); // Send focus back to whatever opened the drawer
		// (the header cart icon, or the add-to-cart button that triggered it)

		if (this.lastFocusedElement) {
			$(this.lastFocusedElement).trigger('focus');
			this.lastFocusedElement = null;
		}
	},
	lockBodyScroll: function lockBodyScroll() {
		// position:fixed (rather than just overflow:hidden) is needed so this
		// also holds on iOS Safari, which otherwise still lets the page behind
		// the drawer scroll/rubber-band on touch or wheel input.
		this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
		$('body').css({
			position: 'fixed',
			top: -this.scrollPosition + 'px',
			left: 0,
			right: 0,
			width: '100%'
		}).addClass('ajax-cart-scroll-lock');
	},
	unlockBodyScroll: function unlockBodyScroll() {
		$('body').css({
			position: '',
			top: '',
			left: '',
			right: '',
			width: ''
		}).removeClass('ajax-cart-scroll-lock');
		window.scrollTo(0, this.scrollPosition || 0);
	},
	trapFocus: function trapFocus(e) {
		var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'; // cart.ajax.liquid renders the upsell block (render 'product-upsell')
		// directly inside <template data-html="content">, which gets injected
		// into #ajax-cart__content - i.e. it's already a real descendant of
		// #theme-ajax-cart once the drawer content has loaded. Widening the
		// scope with a page-wide $('.upsell-product__section') lookup was wrong:
		// if that snippet is reused anywhere else on the site (e.g. a product
		// page), it pulled that OTHER instance into this trap too, scrambling
		// first/last into document order across two unrelated DOM subtrees -
		// which is exactly what made Tab skip the cart's own items and escape
		// out onto the page. Scoping to the drawer alone is both correct and
		// sufficient.

		var $focusable = this.ajaxCartDrawer.find(focusableSelector).filter(':visible');
		if (!$focusable.length) return;
		var first = $focusable[0];
		var last = $focusable[$focusable.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === first || document.activeElement === this.ajaxCartDrawer[0]) {
				e.preventDefault();
				last.focus();
			}
		} else {
			if (document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		}
	},
	removeFromCart: function removeFromCart(lineID, callback) {
		$.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data: 'quantity=0&line=' + lineID,
			dataType: 'json',
			success: function success(cart) {
				Shopify.theme.jsAjaxCart.updateView(function () {
					// The row (and its remove/"close" button) that had focus was just
					// destroyed by replaceWith() in updateView, which silently drops
					// focus back to <body>. Send it somewhere useful instead and
					// announce the removal for screen-reader users.
					var announceText = Shopify.translation && Shopify.translation.item_removed ? Shopify.translation.item_removed : 'Item removed from cart.';
					$('[data-ajax-cart-announce]').text(announceText);
					var $ajaxCartDrawer = Shopify.theme.jsAjaxCart.ajaxCartDrawer;

					if ($ajaxCartDrawer && $ajaxCartDrawer.hasClass('is-visible')) {
						$ajaxCartDrawer.find('[data-ajax-cart-close]').trigger('focus');
					}

					if (typeof callback === 'function') callback(cart);
				});
			},
			error: function error(XMLHttpRequest, textStatus) {
				var response = eval('(' + XMLHttpRequest.responseText + ')');
				response = response.description;
			}
		});
	},
	initializeAjaxCart: function initializeAjaxCart() {
		Shopify.theme.asyncView.load('/cart', // template name
			'ajax' // view name (suffix)
		).done(function (_ref) {
			var html = _ref.html,
				options = _ref.options;
			$('[data-ajax-cart-content]').html(html.content);

			if (Shopify.theme_settings.show_multiple_currencies) {
				convertCurrencies();
			}
		}).fail(function () {// some error handling
		});
	},
	initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
		this.toggleMiniCart();
		Shopify.theme.asyncView.load('/cart', // template name
			'ajax' // view name (suffix)
		).done(function (_ref2) {
			var html = _ref2.html,
				options = _ref2.options;
			$('.mobile-header [data-ajax-cart-content]').html(html.content);

			if (Shopify.theme_settings.show_multiple_currencies) {
				convertCurrencies();
			}
		}).fail(function () {// some error handling
		});
	},
	addToCart: function addToCart($addToCartForm) {
		var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
		$.ajax({
			url: '/cart/add.js',
			dataType: 'json',
			cache: false,
			type: 'post',
			data: $addToCartForm.serialize(),
			beforeSend: function beforeSend() {
				$addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
				$addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
			},
			success: function success(product) {
				var $el = $('[data-ajax-cart-trigger]');
				$addToCartBtn.find('.checkmark').addClass('checkmark-active'); // Tell screen-reader users the item was added, since focus is about
				// to move into the cart drawer (see showDrawer) rather than staying
				// on the button they just activated

				var announceText = (Shopify.translation && Shopify.translation.added_to_cart ? Shopify.translation.added_to_cart : '{{ product }} has been added to your cart.').replace('{{ product }}', product.title);
				$('[data-ajax-cart-announce]').text(announceText);

				function addedToCart() {
					if (!isScreenSizeLarge()) {
						$el = $('.mobile-header [data-ajax-cart-trigger]');
						Shopify.theme.scrollToTop($el);
					} else {
						$el = $('[data-ajax-cart-trigger]');
					}

					$el.addClass('show-mini-cart');
					$addToCartBtn.find('span').removeClass('fadeInDown');
				}

				window.setTimeout(function () {
					$addToCartBtn.removeAttr('disabled').removeClass('disabled');
					$addToCartBtn.find('.checkmark').removeClass('checkmark-active');
					$addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
					$addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
				}, 1000);
				Shopify.theme.jsAjaxCart.showDrawer();
				Shopify.theme.jsAjaxCart.updateView();
				Shopify.theme.jsAjaxCart.updateUpsellSlider();

				if (Shopify.theme.jsCart) {
					var _$$ajax;

					$.ajax((_$$ajax = {
						dataType: "json",
						async: false,
						cache: false
					}, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
						var cartForm = $(html).find('.cart__form');
						$('.cart__form').replaceWith(cartForm);

						if (Shopify.theme_settings.show_multiple_currencies) {
							convertCurrencies();
						}
					}), _$$ajax));
				}
			},
			error: function error(XMLHttpRequest) {
				var response = eval('(' + XMLHttpRequest.responseText + ')');
				response = response.description;
				var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
				$('.warning').remove();
				$addToCartForm.find('.cart-warning').html(cartWarning);
				$addToCartBtn.removeAttr('disabled').removeClass('disabled');
				$addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
				$addToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
			}
		});
	},
	updateUpsellSlider: function updateUpsellSlider() {
		var cartItems = [];
		$.ajax({
			url: '/cart.js',
			dataType: 'json',
			success: function (cart) {
				cartItems = cart.items.map(function (item) {
					return item.product_id;
				});

				var $upsellSlider = $('swiper-upsell');
				$upsellSlider.find('.swiper-slide').each(function () {
					var productId = $(this).data('product-id');
					if (cartItems.includes(productId)) {
						$(this).remove();
					}
				});

				var swiperInstance = $upsellSlider[0].swiper;
				if (swiperInstance) {
					swiperInstance.update();
				}
			}
		});
	},
	updateView: function updateView(callback) {
		Shopify.theme.asyncView.load('/cart', // template name
			'ajax' // view name (suffix)
		).done(function (_ref3) {
			var html = _ref3.html,
				options = _ref3.options;

			if (options.item_count > 0) {
				var itemList = $(html.content).find('.ajax-cart__list');
				var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
				$('.ajax-cart__list').replaceWith(itemList);
				$('.ajax-cart__details-wrapper').replaceWith(cartDetails);
				$('.ajax-cart__empty-cart-message').addClass('is-hidden');
				$('.ajax-cart__form').removeClass('is-hidden');
				$('[data-ajax-cart-trigger]').addClass('has-cart-count');
				$('[data-bind="itemCount"]').text(options.item_count);
			} else {
				$('.ajax-cart__empty-cart-message').removeClass('is-hidden');
				$('.ajax-cart__form').addClass('is-hidden');
				$('[data-ajax-cart-trigger]').removeClass('has-cart-count');
				$('[data-bind="itemCount"]').text('0');
			}

			if (Shopify.theme_settings.show_multiple_currencies) {
				convertCurrencies();
			}

			if (typeof callback === 'function') callback();
		}).fail(function () {// some error handling
		});
	},
	unload: function unload($section) {
		// Clear event listeners in theme editor
		$('.ajax-submit').off();
		$('[data-ajax-cart-delete]').off();
	}
};